

import request from "superagent";

import { toast } from "sonner";
import { DiscoveryApi } from "../discovery-api";
import { renderErrorToast } from "../../../lib/ErrorToastMessage";
class BillingAPI extends DiscoveryApi {
  routePrefix = "billing";

  getEndpoint(route: string) {
    const apiEndpoint =
      process.env.NEXT_PUBLIC_DISCOVERY_URI ||
      "https://ft45cm83v6.execute-api.us-west-2.amazonaws.com/prod";
    return `${apiEndpoint}/${this.routePrefix}${route}`;
  }

  getCustomer(
    accessToken: string,
    callback: any
  ) {
    const route = "/customer";
    const endpoint = this.getEndpoint(route);

    return request
      .get(endpoint)
      .query({ accessToken })
      .end((err, res) => {
        if (err || !res.ok) {
          callback(err, null);
        } else {
          callback(null, res);
        }
      });
  }

  createCustomer(
    requestData: BillingAPI.ChangeCustomerRequest,
    callback?: any
  ) {
    const route = "/customer";
    const endpoint = this.getEndpoint(route);

    return request
      .post(endpoint)
      .query(requestData)
      .end((err, res) => {
        if (err || !res.ok) {
          renderErrorToast(err?.message);
          callback(err, null);
        } else {
          toast.success("Card data successfully created");
          callback(null, res);
        }
      });
  }

  updateCustomer(
    requestData: BillingAPI.ChangeCustomerRequest,
  ) {
    const route = "/customer";
    const endpoint = this.getEndpoint(route);

    return request
      .put(endpoint)
      .query(requestData)
      .end((err, res) => {
        if (err || !res.ok) {
          renderErrorToast(err?.message);
          // console.log(err, null);
        } else {
          toast.success("Card data successfully updated");
          // console.log(null, res);
        }
      });
  }

  createUserInvoice(
    requestData: BillingAPI.UserInvoiceRequest,
  ) {
    const route = "/invoice/user";
    const endpoint = this.getEndpoint(route);

    return request
      .post(endpoint)
      .query(requestData)
      .end((err, res) => {
        if (err || !res.ok) {
          renderErrorToast(err?.message);
          // callback(err, null);
        } else {
          toast.success("Billing successfully completed");
          // callback(null, res);
        }
      });
  }

  createLicenseRequest(
    requestData: BillingAPI.LicenseRequestRequest,
    callback?: any
  ) {
    const route = "/invoice/request";
    const endpoint = this.getEndpoint(route);

    return request
      .post(endpoint)
      .query(requestData)
      .end((err, res) => {
        if (err || !res.ok) {
          renderErrorToast(err?.message);
          // console.error(err, null);
        } else {
          toast.success("License creation done");
          // console.log(null, res);
        }
      });
  }

  reserveToken(requestData: BillingAPI.ReserveTokenRequest, callback?: any) {
    const route = "/invoice/reservetoken";
    const endpoint = this.getEndpoint(route);

    return request
     .put(endpoint)
     .query(requestData)
     .end((err, res) => {
      if (err || !res.ok) {
        renderErrorToast(err?.message);
        // console.error(err, null);
      } else {
        toast.success("License creation done");
        // console.log(null, res);
      };
    })
  }

  getProduct(
    requestData: BillingAPI.ProductRequest,
    callback: any
  ) {
    const route = "/product";
    const endpoint = this.getEndpoint(route);

    return request
      .get(endpoint)
      .query(requestData)
      .end((err, res) => {
        if (err || !res.ok) {
          callback(err, null);
        } else {
          callback(null, res);
        }
      });
  }
}

export let billingAPI = new BillingAPI();
if (process.env.NEXT_PUBLIC_DEVELOPMENT)
  (typeof window !== "undefined" ? window : {})["billing"] = billingAPI;
